module.exports = __webpack_public_path__ + "static/mr-press-11-d08385385fc738ebff6883654c675450.jpg";